import { createNamespacedHelpers, Module } from "vuex";
import { state } from "./state";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";
import {
  CountyState,
  CountyGetters,
  CountyMutations,
  CountyActions
} from "./types";

const namespaced = true;
export const namespace = "county";

export const {
  mapState: countyMapState,
  mapGetters: countyMapGetters,
  mapMutations: countyMapMutations,
  mapActions: countyMapActions
} = createNamespacedHelpers<
  CountyState,
  CountyGetters,
  CountyMutations,
  CountyActions
>(namespace);

export const county: Module<CountyState, any> = {
  namespaced,
  state,
  getters,
  mutations,
  actions
};
